import { useMemo } from "react"

export function ellipsis(value: string, limit: number) {
  if (value.length < limit) {
    return value
  }

  value = value.slice(0, limit - 3)
  value = value.slice(0, value.lastIndexOf(" "))

  return value + "..."
}

export function useFeedSize(columns: number, items: number) {
  return useMemo(() => {
    items = Math.max(items, 0)
    if (items === 0) {
      return 1
    }

    columns = Math.max(columns, 1)
    return Math.ceil(items / columns)
  }, [columns, items])
}

export function useFeedColumnName(size?: number, defaultValue = 4) {
  size = Math.max(1, Math.min(size ?? defaultValue, 6))

  return useMemo(() => {
    switch (size) {
      case 1:
        return "Feed__Item--one-columns"
      case 2:
        return "Feed__Item--two-columns"
      case 3:
        return "Feed__Item--three-columns"
      case 5:
        return "Feed__Item--five-columns"
      case 6:
        return "Feed__Item--six-columns"
      case 4:
      default:
        return "Feed__Item--four-columns"
    }
  }, [size])
}
